import { SelectField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { SelectFieldAdapterProps } from './SelectFieldAdapter.types';

const SelectFieldAdapter = (props: SelectFieldAdapterProps): JSX.Element => {
  const { field, form, options, error, label, qualifying, onFieldChange } = props;

  const handleChange = (event: React.FormEvent<HTMLSelectElement>): void => {
    field.onChange(event);
    if (onFieldChange) {
      onFieldChange(field.name, event.currentTarget.value);
    }
    analytics.dropdownSelect(field.name, event.currentTarget.value);
  };

  const selectError = qualifying ? error : form.errors[field.name];

  return (
    <SelectField
      name={field.name}
      label={label}
      value={field.value}
      touched={form.errors[field.name] !== undefined && form.touched[field.name]}
      error={selectError}
      options={options}
      onBlur={field.onBlur}
      onChange={handleChange}
    />
  );
};

export { SelectFieldAdapter as default };
